import { gql } from "@apollo/client";

export const SET_USER_PREFERENCE = gql`
  mutation SET_USER_PREFERENCE($id: uuid = "", $userSettings: jsonb = "") {
    update_users_by_pk(
      pk_columns: { id: $id }
      _set: { userSettings: $userSettings }
    ) {
      userSettings
      id
    }
}`;

export const FIRST_ONBOARDING_BOOLEAN_UPDATE = gql`
  mutation FIRST_ONBOARDING_BOOLEAN_UPDATE($userId: uuid = "", $userAppSettings: jsonb = "") {
    update_users_by_pk(pk_columns: {id: $userId}, _set: {userAppSettings: $userAppSettings}) {
      id
      userAppSettings
    }
  }
`;

export const CREATE_REFERRAL = gql`
mutation CreateRefferal($create_by: uuid = "", $expires_at: timestamptz = "") {
  insert_refferal_link_one(object: {create_by: $create_by, expires_at: $expires_at}) {
    id
  }
}`

export const INSERT_RECIPE = gql`
mutation insertUserGeneratedRecipes($recipeData: jsonb = "", $userId: uuid = "", $recipe_Id: uuid = "") {
  insert_User_Generated_Recipes_one(object: {recipeData: $recipeData, userId: $userId, recipe_Id: $recipe_Id}) {
    recipeData
  }
}
`

export const ADD_RECIPE_TO_FAVORITE = gql`
mutation addRecipeToFavorite($recipeId: String = "",$userId: uuid = "") {
  insert_User_favourite_recipes_one(object: {recipeId: $recipeId, userId: $userId}) {
    id
    recipeId
    userId
  }
}
`

export const REMOVE_RECIPE_FROM_FAVORITE = gql`
mutation removeRecipeFromFavorite($recipeId: String = "", $userId: uuid = "") {
  delete_User_favourite_recipes(where: {recipeId: {_eq: $recipeId}, userId: {_eq: $userId}}) {
    returning {
      id
      recipeId
      userId
    }
  }
}
`

export const MODIFY_RECIPE_DATA = gql`
mutation modifyRecipeData($recipeId: uuid = "", $recipeData: jsonb = "") {
  update_User_Generated_Recipes(where: {recipe_Id: {_eq: $recipeId}}, _set: {recipeData: $recipeData}) {
    returning {
      recipeData
    }
  }
}
`

export const DELETE_USER_CREATED_RECIPE = gql`
mutation DELETE_USER_CREATED_RECIPE($recipeId: String = "") {
  update_Recipes_E3_by_pk(pk_columns: {id: $recipeId}, _set: {is_deleted: true}) {
      id
   }
}
`

export const INSERT_BAT_SIGNAL_EVENT_DATA = gql`
  mutation insertBatSignalEventData($eventData: jsonb = "") {
    insert_batsignal_one(object: {eventData: $eventData}) {
      eventData
      id
    }
  }
`
export const EDIT_RECIPE_NAME = gql`
  mutation EDIT_RECIPE_NAME($id: String = "", $name: String = "", $lastEditedAt: timestamptz = "") {
    update_Recipes_E3_by_pk(pk_columns: { id: $id }, _set: { name: $name, last_edited_at: $lastEditedAt }) {
      name
      last_edited_at
    }
  }
`;

export const SAVE_NEW_RECIPE = gql`mutation duplicateRecipeMob($recipe: Recipes_E3_insert_input = {}, $recipeVariations: [Recipe_Variations_insert_input!] = {}, $steps: [StepsE3_insert_input!] = {}, $subSteps: [SubstepsE3_insert_input!] = {}, $recipeVariationSteps: [RecipeVariations_Steps_insert_input!] = {}, $stepSubSteps: [Steps_Substeps_insert_input!] = {}, $subStepIngredients: [SubSteps_Ingredients_E3_insert_input!] = {}) {
  insert_Recipes_E3_one(object: $recipe) {
    id
  }
  insert_Recipe_Variations(objects: $recipeVariations) {
    affected_rows
  }
  insert_StepsE3(objects: $steps) {
    affected_rows
  }
  insert_SubstepsE3(objects: $subSteps) {
    affected_rows
  }
  insert_RecipeVariations_Steps(objects: $recipeVariationSteps) {
    affected_rows
  }
  insert_Steps_Substeps(objects: $stepSubSteps) {
    affected_rows
  }
  insert_SubSteps_Ingredients_E3(objects: $subStepIngredients) {
    affected_rows
  }
}`

export const ADD_PRESET = gql`
mutation ADD_PRESET($stepSubstepUpdates: [Steps_Substeps_updates!] = {where: {}}, $recipeVariationId: uuid = "", $cooking_time: numeric = "", $stepSubstepsInserts: [Steps_Substeps_insert_input!] = {}) {
  update_Steps_Substeps_many(updates: $stepSubstepUpdates) {
    affected_rows
  }
  update_Recipe_Variations_by_pk(pk_columns: {id: $recipeVariationId}, _set: {cooking_time: $cooking_time}) {
    id
  }
  insert_Steps_Substeps(objects: $stepSubstepsInserts) {
    affected_rows
  }
}
`

export const ADD_INSTRUCTION = gql`
mutation ADD_INSTRUCTION($substepInserts: [SubstepsE3_insert_input!] = {}, $stepSubstepsInserts: [Steps_Substeps_insert_input!] = {}, $stepSubstepUpdates: [Steps_Substeps_updates!] = {where: {}}, $recipeVariationId: uuid = "", $cooking_time: numeric = "") {
  insert_SubstepsE3(objects: $substepInserts) {
    affected_rows
  }
  insert_Steps_Substeps(objects: $stepSubstepsInserts) {
    affected_rows
  }
  update_Steps_Substeps_many(updates: $stepSubstepUpdates) {
    affected_rows
  }
  update_Recipe_Variations_by_pk(pk_columns: {id: $recipeVariationId}, _set: {cooking_time: $cooking_time}) {
    id
  }
}
`

export const ADD_OUTSIDE_INSTRUCTION = gql`
mutation ADD_OUTSIDE_INSTRUCTION($substepInserts: [SubstepsE3_insert_input!] = {}, $stepSubstepsInserts: [Steps_Substeps_insert_input!] = {}, $stepSubstepUpdates: [Steps_Substeps_updates!] = {where: {}}) {
  insert_SubstepsE3(objects: $substepInserts) {
    affected_rows
  }
  insert_Steps_Substeps(objects: $stepSubstepsInserts) {
    affected_rows
  }
  update_Steps_Substeps_many(updates: $stepSubstepUpdates) {
    affected_rows
  }
}

`

export const INITIALIZE_PRESET = gql`
mutation INITIALIZE_PRESET($stepDataInsert: StepsE3_insert_input = {}, $recipeVarStepsInsert: RecipeVariations_Steps_insert_input = {}, $stepSubstepInsert: Steps_Substeps_insert_input = {}, $recipeVariationId: uuid = "", $cooking_time: numeric = "") {
  insert_StepsE3_one(object: $stepDataInsert) {
    id
  }
  insert_RecipeVariations_Steps_one(object: $recipeVarStepsInsert) {
    id
  }
  insert_Steps_Substeps_one(object: $stepSubstepInsert) {
    id
  }
  update_Recipe_Variations_by_pk(pk_columns: {id: $recipeVariationId}, _set: {cooking_time: $cooking_time}) {
    id
  }
}
`

export const INITIALIZE_INSTRUCTION = gql`
mutation INITIALIZE_INSTRUCTION($stepDataInsert: StepsE3_insert_input = {}, $recipeVarStepsInsert: RecipeVariations_Steps_insert_input = {}, $stepSubstepInsert: Steps_Substeps_insert_input = {}, $recipeVariationId: uuid = "", $cooking_time: numeric = "", $newSubstep: SubstepsE3_insert_input = {}) {
  insert_SubstepsE3_one(object: $newSubstep) {
    id
  }
  insert_StepsE3_one(object: $stepDataInsert) {
    id
  }
  insert_RecipeVariations_Steps_one(object: $recipeVarStepsInsert) {
    id
  }
  insert_Steps_Substeps_one(object: $stepSubstepInsert) {
    id
  }
  update_Recipe_Variations_by_pk(pk_columns: {id: $recipeVariationId}, _set: {cooking_time: $cooking_time}) {
    id
  }

}

`

export const INITIALIZE_OUTSIDE_INSTRUCTION = gql`
mutation INITIALIZE_OUTSIDE_INSTRUCTION($newSubstep: SubstepsE3_insert_input = {}, $stepDataInsert: StepsE3_insert_input = {}, $recipeVarStepsInsert: RecipeVariations_Steps_insert_input = {}, $stepSubstepInsert: Steps_Substeps_insert_input = {}) {
  insert_SubstepsE3_one(object: $newSubstep) {
    id
  }
  insert_StepsE3_one(object: $stepDataInsert) {
    id
  }
  insert_RecipeVariations_Steps_one(object: $recipeVarStepsInsert) {
    id
  }
  insert_Steps_Substeps_one(object: $stepSubstepInsert) {
    id
  }
}
`

export const INSTRUCTION_TO_PRESET = gql`
mutation INSTRUCTION_TO_PRESET($subStep_id: String = "", $stepSubstepId: uuid = "", $recipeVariationId: uuid = "", $cooking_time: numeric = "", $substepIdToDelete: String = "") {
  update_Steps_Substeps_by_pk(pk_columns: {id: $stepSubstepId}, _set: {subStep_id: $subStep_id}) {
    id
  }
  update_Recipe_Variations_by_pk(pk_columns: {id: $recipeVariationId}, _set: {cooking_time: $cooking_time}) {
    id
  }
  delete_SubstepsE3_by_pk(id: $substepIdToDelete) {
    id
  }
}
`

export const INSTRUCTION_TO_OUTSIDE_INSTRUCTION = gql`
mutation INSTRUCTION_TO_OUTSIDE_INSTRUCTION($substepId: String = "", $newSubstep: SubstepsE3_set_input = {}, $recipeVariationId: uuid = "", $cooking_time: numeric = "") {
  update_SubstepsE3_by_pk(pk_columns: {id: $substepId}, _set: $newSubstep) {
    id
  }
  update_Recipe_Variations_by_pk(pk_columns: {id: $recipeVariationId}, _set: {cooking_time: $cooking_time}) {
    id
  }
}
`
export const INSTRUCTION_TO_INGREDIENT = gql`
mutation INSTRUCTION_TO_INGREDIENT($oldSubstepId: String = "", $newSubstep: SubstepsE3_set_input = {}, $ingredientsInsert: [Ingredients_DB_insert_input!] = {}, $substepIngredientIdsToAdd: [SubSteps_Ingredients_E3_insert_input!] = {}, $recipeVariationId: uuid = "", $cooking_time: numeric = "", $newIngredientsList: jsonb = "", $updatedMetadata: jsonb = {}) {
  update_SubstepsE3_by_pk(pk_columns: {id: $oldSubstepId}, _set: $newSubstep) {
    id
  }
  insert_Ingredients_DB(objects: $ingredientsInsert) {
    affected_rows
  }
  insert_SubSteps_Ingredients_E3(objects: $substepIngredientIdsToAdd) {
    affected_rows
  }
  update_Recipe_Variations_by_pk(pk_columns: {id: $recipeVariationId}, _set: {cooking_time: $cooking_time, ingredients: $newIngredientsList, metadata: $updatedMetadata}) {
    id
  }
}
`

export const INSTRUCTION_TO_INSTRUCTION = gql`
mutation INSTRUCTION_TO_INSTRUCTION($substepId: String = "", $newSubstep: SubstepsE3_set_input = {}, $recipeVariationId: uuid = "", $cooking_time: numeric = "") {
  update_SubstepsE3_by_pk(pk_columns: {id: $substepId}, _set: $newSubstep) {
    id
  }
  update_Recipe_Variations_by_pk(pk_columns: {id: $recipeVariationId}, _set: {cooking_time: $cooking_time}) {
    id
  }
}
`

export const OUTSIDE_INSTRUCTION_TO_INSTRUCTION = gql`
mutation OUTSIDE_INSTRUCTION_TO_INSTRUCTION($substepId: String = "", $newSubstep: SubstepsE3_set_input = {}, $recipeVariationId: uuid = "", $cooking_time: numeric = "") {
  update_SubstepsE3_by_pk(pk_columns: {id: $substepId}, _set: $newSubstep) {
    id
  }
  update_Recipe_Variations_by_pk(pk_columns: {id: $recipeVariationId}, _set: {cooking_time: $cooking_time}) {
    id
  }
}
`
export const OUTSIDE_INSTRUCTION_TO_PRESET = gql`
mutation OUTSIDE_INSTRUCTION_TO_PRESET($stepSubstepId: uuid = "", $subStep_id: String = "", $recipeVariationId: uuid = "", $cooking_time: numeric = "", $substepIdToDelete: String = "") {
  update_Steps_Substeps_by_pk(pk_columns: {id: $stepSubstepId}, _set: {subStep_id: $subStep_id}) {
    id
  }
  update_Recipe_Variations_by_pk(pk_columns: {id: $recipeVariationId}, _set: {cooking_time: $cooking_time}) {
    id
  }
  delete_SubstepsE3_by_pk(id: $substepIdToDelete) {
    id
  }
}
`

export const OUTSIDE_INSTRUCTION_TO_OUTSIDE_INSTRUCTION = gql`
mutation OUTSIDE_INSTRUCTION_TO_OUTSIDE_INSTRUCTION($substepId: String = "", $newSubstep: SubstepsE3_set_input = {}) {
  update_SubstepsE3_by_pk(pk_columns: {id: $substepId}, _set: $newSubstep) {
    id
  }
}
`
export const OUTSIDE_INSTRUCTION_TO_INGREDIENT = gql`
mutation OUTSIDE_INSTRUCTION_TO_INGREDIENT($oldSubstepId: String = "", $newSubstep: SubstepsE3_set_input = {}, $ingredientsInsert: [Ingredients_DB_insert_input!] = {}, $substepIngredientIdsToAdd: [SubSteps_Ingredients_E3_insert_input!] = {}, $recipeVariationId: uuid = "", $newIngredientsList: jsonb = "", $updatedMetadata: jsonb = {}) {
  update_SubstepsE3_by_pk(pk_columns: {id: $oldSubstepId}, _set: $newSubstep) {
    id
  }
  insert_Ingredients_DB(objects: $ingredientsInsert) {
    affected_rows
  }
  insert_SubSteps_Ingredients_E3(objects: $substepIngredientIdsToAdd) {
    affected_rows
  }
  update_Recipe_Variations_by_pk(pk_columns: {id: $recipeVariationId}, _set: {ingredients: $newIngredientsList, metadata: $updatedMetadata}) {
    id
  }
}
`

export const PRESET_TO_INSTRUCTION = gql`
mutation PRESET_TO_INSTRUCTION($newSubstep: SubstepsE3_insert_input = {}, $stepSubstepId: uuid = "", $subStep_id: String = "", $recipeVariationId: uuid = "", $cooking_time: numeric = "") {
  insert_SubstepsE3_one(object: $newSubstep) {
    id
  }
  update_Steps_Substeps_by_pk(pk_columns: {id: $stepSubstepId}, _set: {subStep_id: $subStep_id}) {
    id
  }
  update_Recipe_Variations_by_pk(pk_columns: {id: $recipeVariationId}, _set: {cooking_time: $cooking_time}) {
    id
  }
}
`
export const PRESET_TO_OUTSIDE_INSTRUCTION = gql`
mutation PRESET_TO_OUTSIDE_INSTRUCTION($newSubstep: SubstepsE3_insert_input = {}, $stepSubstepId: uuid = "", $subStep_id: String = "", $recipeVariationId: uuid = "", $cooking_time: numeric = "") {
  insert_SubstepsE3_one(object: $newSubstep) {
    id
  }
  update_Steps_Substeps_by_pk(pk_columns: {id: $stepSubstepId}, _set: {subStep_id: $subStep_id}) {
    id
  }
  update_Recipe_Variations_by_pk(pk_columns: {id: $recipeVariationId}, _set: {cooking_time: $cooking_time}) {
    id
  }
}
`
export const PRESET_TO_INGREDIENT = gql`
mutation PRESET_TO_INGREDIENT($newSubstep: SubstepsE3_insert_input = {}, $stepSubstepId: uuid = "", $subStep_id: String = "", $ingredientsInsert: [Ingredients_DB_insert_input!] = {}, $recipeVariationId: uuid = "", $cooking_time: numeric = "", $newIngredientsList: jsonb = "", $substepIngredientIdsToAdd: [SubSteps_Ingredients_E3_insert_input!] = {}, $updatedMetadata: jsonb = {}) {
  insert_SubstepsE3_one(object: $newSubstep) {
    id
  }
  update_Steps_Substeps_by_pk(pk_columns: {id: $stepSubstepId}, _set: {subStep_id: $subStep_id}) {
    id
  }
  insert_Ingredients_DB(objects: $ingredientsInsert) {
    affected_rows
  }
  update_Recipe_Variations_by_pk(pk_columns: {id: $recipeVariationId}, _set: {cooking_time: $cooking_time, ingredients: $newIngredientsList, metadata: $updatedMetadata}) {
    id
  }
  insert_SubSteps_Ingredients_E3(objects: $substepIngredientIdsToAdd) {
    affected_rows
  }
}

`

export const PRESET_TO_PRESET = gql`
mutation PRESET_TO_PRESET($stepSubstepId: uuid = "", $subStep_id: String = "", $recipeVariationId: uuid = "", $cooking_time: numeric = "") {
  update_Steps_Substeps_by_pk(pk_columns: {id: $stepSubstepId}, _set: {subStep_id: $subStep_id}) {
    id
  }
  update_Recipe_Variations_by_pk(pk_columns: {id: $recipeVariationId}, _set: {cooking_time: $cooking_time}) {
    id
  }
}
`
export const DELETE_PRESET_STEP = gql`
mutation DELETE_PRESET_STEP($stepId: String = "", $stepSubstepId: uuid = "", $recipeVarStepId: uuid = "", $recipeVarSteps: [RecipeVariations_Steps_updates!] = {where: {}}, $recipeVariationId: uuid = "", $cooking_time: numeric = "") {
  delete_StepsE3_by_pk(id: $stepId) {
    id
  }
  delete_Steps_Substeps_by_pk(id: $stepSubstepId) {
    id
  }
  delete_RecipeVariations_Steps_by_pk(id: $recipeVarStepId) {
    id
  }
  update_RecipeVariations_Steps_many(updates: $recipeVarSteps) {
    affected_rows
  }
  update_Recipe_Variations_by_pk(pk_columns: {id: $recipeVariationId}, _set: {cooking_time: $cooking_time}) {
    id
  }
}
`

export const DELETE_INSTRUCTION_STEP = gql`
mutation DELETE_INSTRUCTION_STEP($stepId: String = "", $substepId: String = "", $recipeVarStepId: uuid = "", $stepSubstepId: uuid = "", $recipeVarSteps: [RecipeVariations_Steps_updates!] = {where: {}}, $recipeVariationId: uuid = "", $cooking_time: numeric = "") {
  delete_StepsE3_by_pk(id: $stepId) {
    id
  }
  delete_SubstepsE3_by_pk(id: $substepId) {
    id
  }
  delete_RecipeVariations_Steps_by_pk(id: $recipeVarStepId) {
    id
  }
  delete_Steps_Substeps_by_pk(id: $stepSubstepId) {
    id
  }
  update_RecipeVariations_Steps_many(updates: $recipeVarSteps) {
    affected_rows
  }
  update_Recipe_Variations_by_pk(pk_columns: {id: $recipeVariationId}, _set: {cooking_time: $cooking_time}) {
    id
  }
}

`

export const DELETE_OUTSIDE_INSTRUCTION_STEP = gql`
mutation DELETE_OUTSIDE_INSTRUCTION_STEP($stepId: String = "", $substepId: String = "", $stepSubstepId: uuid = "", $recipeVarStepId: uuid = "", $recipeVarSteps: [RecipeVariations_Steps_updates!] = {where: {}}) {
  delete_StepsE3_by_pk(id: $stepId) {
    id
  }
  delete_SubstepsE3_by_pk(id: $substepId) {
    id
  }
  delete_Steps_Substeps_by_pk(id: $stepSubstepId) {
    id
  }
  delete_RecipeVariations_Steps_by_pk(id: $recipeVarStepId) {
    id
  }
  update_RecipeVariations_Steps_many(updates: $recipeVarSteps) {
    affected_rows
  }
}
`
export const DELETE_INGREDIENT_STEP = gql`
mutation DELETE_INGREDIENT_STEP($stepId: String = "", $substepId: String = "", $stepSubstepId: uuid = "", $recipeVarStepId: uuid = "", $recipeVarSteps: [RecipeVariations_Steps_updates!] = {where: {}}, $substepIngredientIdsToDelete: [uuid!] = "", $recipeVariationId: uuid = "", $newIngredientsList: jsonb = "", $updatedMetadata: jsonb = {}) {
  delete_StepsE3_by_pk(id: $stepId) {
    id
  }
  delete_SubstepsE3_by_pk(id: $substepId) {
    id
  }
  delete_Steps_Substeps_by_pk(id: $stepSubstepId) {
    id
  }
  delete_RecipeVariations_Steps_by_pk(id: $recipeVarStepId) {
    id
  }
  update_RecipeVariations_Steps_many(updates: $recipeVarSteps) {
    affected_rows
  }
  delete_SubSteps_Ingredients_E3(where: {id: {_in: $substepIngredientIdsToDelete}}) {
    affected_rows
  }
  update_Recipe_Variations_by_pk(pk_columns: {id: $recipeVariationId}, _set: {ingredients: $newIngredientsList, metadata: $updatedMetadata}) {
    id
  }
}
`

export const DELETE_PRESET_SUBSTEP = gql`
mutation DELETE_PRESET_SUBSTEP($stepSubstepId: uuid = "", $stepSubstepUpdates: [Steps_Substeps_updates!] = {where: {}}, $recipeVariationId: uuid = "", $cooking_time: numeric = "") {
  delete_Steps_Substeps_by_pk(id: $stepSubstepId) {
    id
  }
  update_Steps_Substeps_many(updates: $stepSubstepUpdates) {
    affected_rows
  }
  update_Recipe_Variations_by_pk(pk_columns: {id: $recipeVariationId}, _set: {cooking_time: $cooking_time}) {
    id
  }
}
`
export const DELETE_INSTRUCTION_SUBSTEP = gql`
mutation DELETE_INSTRUCTION_SUBTEP($substepId: String = "", $stepSubstepId: uuid = "", $stepSubstepUpdates: [Steps_Substeps_updates!] = {where: {}}, $recipeVariationId: uuid = "", $cooking_time: numeric = "") {
  delete_SubstepsE3_by_pk(id: $substepId) {
    id
  }
  delete_Steps_Substeps_by_pk(id: $stepSubstepId) {
    id
  }
  update_Steps_Substeps_many(updates: $stepSubstepUpdates) {
    affected_rows
  }
  update_Recipe_Variations_by_pk(pk_columns: {id: $recipeVariationId}, _set: {cooking_time: $cooking_time}) {
    id
  }
}
`

export const DELETE_INGREDIENT_SUBSTEP = gql`
mutation DELETE_INGREDIENT_SUBSTEP($substepId: String = "", $stepSubstepId: uuid = "", $stepSubstepUpdates: [Steps_Substeps_updates!] = {where: {}}, $substepIngredientIdsToDelete: [uuid!] = "", $recipeVariationId: uuid = "", $newIngredientsList: jsonb = "", $updatedMetadata: jsonb = {}) {
  delete_SubstepsE3_by_pk(id: $substepId) {
    id
  }
  delete_Steps_Substeps_by_pk(id: $stepSubstepId) {
    id
  }
  update_Steps_Substeps_many(updates: $stepSubstepUpdates) {
    affected_rows
  }
  delete_SubSteps_Ingredients_E3(where: {id: {_in: $substepIngredientIdsToDelete}}) {
    affected_rows
  }
  update_Recipe_Variations_by_pk(pk_columns: {id: $recipeVariationId}, _set: {ingredients: $newIngredientsList, metadata: $updatedMetadata}) {
    id
  }
}
`

export const DELETE_OUTSIDE_INSTRUCTION_SUBSTEP = gql`
mutation DELETE_OUTSIDE_INSTRUCTION_SUBSTEP($substepId: String = "", $stepSubstepId: uuid = "", $stepSubstepUpdates: [Steps_Substeps_updates!] = {where: {}}) {
  delete_SubstepsE3_by_pk(id: $substepId) {
    id
  }
  delete_Steps_Substeps_by_pk(id: $stepSubstepId) {
    id
  }
  update_Steps_Substeps_many(updates: $stepSubstepUpdates) {
    affected_rows
  }
}
`

export const DELETE_MEAL = gql`
  mutation DELETE_MEAL($id: uuid!) {
    delete_Meal_by_pk(id: $id) {
      id
    }
  }
`;

export const ADD_INGREDIENT = gql`
mutation ADD_INGREDIENT(
  $substepInserts: [SubstepsE3_insert_input!] = {}, 
  $stepSubstepsInserts: [Steps_Substeps_insert_input!] = {}, 
  $stepSubstepUpdates: [Steps_Substeps_updates!] = {where: {}}, 
  $ingredientsInsert: [Ingredients_DB_insert_input!] = {}, 
  $recipeVariationId: uuid = "", 
  $ingredientIdList: jsonb = "", 
  $substepIngredients: [SubSteps_Ingredients_E3_insert_input!] = {},
  $updatedMetadata: jsonb = {}
) {
  insert_SubstepsE3(objects: $substepInserts) {
    affected_rows
  }
  insert_Steps_Substeps(objects: $stepSubstepsInserts) {
    affected_rows
  }
  update_Steps_Substeps_many(updates: $stepSubstepUpdates) {
    affected_rows
  }
  insert_Ingredients_DB(objects: $ingredientsInsert) {
    affected_rows
  }
  update_Recipe_Variations_by_pk(
    pk_columns: {id: $recipeVariationId}, 
    _set: {
      ingredients: $ingredientIdList, 
      metadata: $updatedMetadata
    }
  ) {
    id
    metadata
  }
  insert_SubSteps_Ingredients_E3(objects: $substepIngredients) {
    affected_rows
  }
}
`;


export const INITIALIZE_INGREDIENT = gql`
mutation INITIALIZE_INGREDIENT($stepDataInsert: StepsE3_insert_input = {}, $substepInsert: SubstepsE3_insert_input = {}, $recipeVarStepsInsert: RecipeVariations_Steps_insert_input = {}, $stepSubstepsInserts: Steps_Substeps_insert_input = {}, $ingredientsInsert: [Ingredients_DB_insert_input!] = {}, $substepIngredients: [SubSteps_Ingredients_E3_insert_input!] = {}, $recipeVariationId: uuid = "", $ingredientIdList: jsonb = "", $updatedMetadata: jsonb = {}) {
  insert_StepsE3_one(object: $stepDataInsert) {
    id
  }
  insert_SubstepsE3_one(object: $substepInsert) {
    id
  }
  insert_RecipeVariations_Steps_one(object: $recipeVarStepsInsert) {
    id
  }
  insert_Steps_Substeps_one(object: $stepSubstepsInserts) {
    id
  }
  insert_Ingredients_DB(objects: $ingredientsInsert) {
    affected_rows
  }
  insert_SubSteps_Ingredients_E3(objects: $substepIngredients) {
    affected_rows
  }
  update_Recipe_Variations_by_pk(pk_columns: {id: $recipeVariationId}, _set: {ingredients: $ingredientIdList, metadata: $updatedMetadata}) {
    id
  }
}
`

export const INGREDIENT_TO_INSTRUCTION = gql`
mutation INGREDIENT_TO_INSTRUCTION($substepId: String = "", $newSubstep: SubstepsE3_set_input = {}, $substepIngredientIds: [uuid!] = "", $recipeVariationId: uuid = "", $cooking_time: numeric = "", $newIngredientsList: jsonb = "", $updatedMetadata: jsonb = {}) {
  update_SubstepsE3_by_pk(pk_columns: {id: $substepId}, _set: $newSubstep) {
    id
  }
  delete_SubSteps_Ingredients_E3(where: {id: {_in: $substepIngredientIds}}) {
    affected_rows
  }
  update_Recipe_Variations_by_pk(pk_columns: {id: $recipeVariationId}, _set: {cooking_time: $cooking_time, ingredients: $newIngredientsList, metadata: $updatedMetadata}) {
    id
  }
}
`

export const INGREDIENT_TO_PRESET = gql`
mutation INGREDIENT_TO_PRESET($stepSubstepId: uuid = "", $newSubstepId: String = "", $oldSubstepId: String = "", $recipeVariationId: uuid = "", $cooking_time: numeric = "", $newIngredientsList: jsonb = "", $substepIngredientIds: [uuid!] = "", $updatedMetadata: jsonb = {}) {
  update_Steps_Substeps_by_pk(pk_columns: {id: $stepSubstepId}, _set: {subStep_id: $newSubstepId}) {
    id
  }
  delete_SubstepsE3_by_pk(id: $oldSubstepId) {
    id
  }
  update_Recipe_Variations_by_pk(pk_columns: {id: $recipeVariationId}, _set: {cooking_time: $cooking_time, ingredients: $newIngredientsList, metadata: $updatedMetadata}) {
    id
  }
  delete_SubSteps_Ingredients_E3(where: {id: {_in: $substepIngredientIds}}) {
    affected_rows
  }
}
`

export const INGREDIENT_TO_OUTSIDE_INSTRUCTION = gql`
mutation INGREDIENT_TO_OUTSIDE_INSTRUCTION($substepId: String = "", $newSubstep: SubstepsE3_set_input = {}, $substepIngredientIds: [uuid!] = "", $recipeVariationId: uuid = "", $newIngredientsList: jsonb = "", $updatedMetadata: jsonb = {}) {
  update_SubstepsE3_by_pk(pk_columns: {id: $substepId}, _set: $newSubstep) {
    id
  }
  delete_SubSteps_Ingredients_E3(where: {id: {_in: $substepIngredientIds}}) {
    affected_rows
  }
  update_Recipe_Variations_by_pk(pk_columns: {id: $recipeVariationId}, _set: {ingredients: $newIngredientsList, metadata: $updatedMetadata}) {
    id
  }
}
`

export const INGREDIENT_TO_INGREDIENT = gql`
mutation INGREDIENT_TO_INGREDIENT($substepId: String = "", $newSubstep: SubstepsE3_set_input = {}, $ingredientsInsert: [Ingredients_DB_insert_input!] = {}, $substepIngredientIdsToDelete: [uuid!] = "", $substepIngredientIdsToAdd: [SubSteps_Ingredients_E3_insert_input!] = {}, $recipeVariationId: uuid = "", $newIngredientsList: jsonb = "", $updatedMetadata: jsonb = {}) {
  update_SubstepsE3_by_pk(pk_columns: {id: $substepId}, _set: $newSubstep) {
    id
  }
  insert_Ingredients_DB(objects: $ingredientsInsert) {
    affected_rows
  }
  delete_SubSteps_Ingredients_E3(where: {id: {_in: $substepIngredientIdsToDelete}}) {
    affected_rows
  }
  insert_SubSteps_Ingredients_E3(objects: $substepIngredientIdsToAdd) {
    affected_rows
  }
  update_Recipe_Variations_by_pk(pk_columns: {id: $recipeVariationId}, _set: {ingredients: $newIngredientsList, metadata: $updatedMetadata}) {
    id
  }
}

`
export const UPDATE_RECIPE_LAST_UPDATED_AT_AND_TAGS = gql`
mutation UPDATE_RECIPE_LAST_UPDATED_AT_AND_TAGS ($id: String = "", $recipeUpdatedAtAndResetData: Recipes_E3_set_input = {}) {
  update_Recipes_E3_by_pk(pk_columns: {id: $id}, _set: $recipeUpdatedAtAndResetData) {
    id
    
  }
}
`;

export const UPDATE_USER_FCM_TOKENS = gql`mutation UPDATE_USER_FCM_TOKENS($id: uuid = "", $fcm_tokens: jsonb = "") {
  update_users_by_pk(pk_columns: {id: $id}, _set: {fcm_tokens: $fcm_tokens}) {
    fcm_tokens
  }
}`

export const UP_CONNECT_DEVICE_UPDATE_TASK = gql`
mutation UP_CONNECT_DEVICE_UPDATE_TASK($_eq: String = "", $device_queue: jsonb = "", $device_queue_connection_status: String = "", $updated_at_device_queue: timestamp = "") {
  update_Connect(where: {deviceId: {_eq: $_eq}}, _set: {device_queue: $device_queue, device_queue_connection_status: $device_queue_connection_status, updated_at_device_queue: $updated_at_device_queue}) {
    affected_rows
  }
}`

export const UPDATE_RATING = gql`
  mutation UPDATE_RATING($sessionID: String = "", $rating: numeric = "") {
    update_Sessions_DB_by_pk(pk_columns: {sessionID: $sessionID}, _set: {rating: $rating}) {
      sessionID
      deviceID
      recipeID
      userID
      status
      rating
    }
}`

export const UPDATE_USER_FEEDBACK = gql`
  mutation UPDATE_USER_FEEDBACK($sessionID: String = "", $feedback: jsonb = "", $rating: numeric = "", $userComments: String = "",$feebBackImages: jsonb = "") {
    update_Sessions_DB_by_pk(pk_columns: {sessionID: $sessionID}, _set: {rating: $rating, feedback: $feedback, userComments: $userComments, feedback_images: $feebBackImages}) {
      sessionID
    }
}`

export const UPDATE_MEAL_SERVING_SIZE = gql`
  mutation UPDATE_MEAL_SERVING_SIZE($serving_size: Int = "", $id: uuid = "") {
  update_Meal_by_pk(pk_columns: {id: $id}, _set: {serving_size: $serving_size}) {
    id
    servingSize:serving_size
    scheduledDateTime:scheduled_date_time
    mealPlanId:meal_plan_id
    mealType:meal_type
    recipeId:recipe_id
    status
  }
}

`;

export const UPSERT_USER_UPLIANCE_REVIEW = gql`
  mutation UPSERT_USER_UPLIANCE_REVIEW($user_id: uuid!, $review_text: String, $review_image: String) {
    insert_User_Upliance_Review(
      objects: {
        user_id: $user_id,
        review_text: $review_text,
        review_image: $review_image
      },
      on_conflict: {
        constraint: User_Upliance_Review_pkey
        update_columns: [review_text, review_image]
      }
    ) {
      returning {
        review_text
        review_image
      }
    }
  }
`;

export const INSERT_MEAL_PLAN = gql`
  mutation INSERT_MEAL_PLAN($title: String = "", $description: String = "", $author: uuid = "", $author_profile_Image: String = "", $editable: Boolean = true, $access_type: String = "public") {
    insert_Meal_Plan_one(object: {title: $title, description: $description, author: $author, author_profile_Image: $author_profile_Image, editable: $editable, access_type: $access_type}) {
      author
      id
    }
  }
`;

export const INSERT_USER_TO_MEAL_PLAN = gql`
  mutation INSERT_USER_TO_MEAL_PLAN($meal_plan_id: uuid = "", $user_id: uuid = "") {
    insert_User_To_Meal_Plan_one(object: {meal_plan_id: $meal_plan_id, user_id: $user_id}) {
      meal_plan_id
      user_id
    }
  }
`;

export const INSERT_MEAL = gql`
mutation INSERT_MEAL($meal_plan_id: uuid = "", $recipe_id: String = "", $scheduled_date_time: timestamp = "", $serving_size: Int = 2, $status: String = "pending", $meal_type: String = "") {
  insert_Meal(objects: {meal_plan_id: $meal_plan_id, recipe_id: $recipe_id, scheduled_date_time: $scheduled_date_time, serving_size: $serving_size, status: $status, meal_type: $meal_type}) {
    returning {
      id
      recipeId:recipe_id
      servingSize:serving_size
      scheduledDateTime:scheduled_date_time
      mealType:meal_type
      mealPlanId:meal_plan_id
      status
    }
  }
}
`

export const INSERT_MEALS_MANY = gql`
  mutation INSERT_MEALS($meals: [Meal_insert_input!]!) {
    insert_Meal(objects: $meals) {
      returning {
        id
        recipeId:recipe_id
        servingSize:serving_size
        scheduledDateTime:scheduled_date_time
        mealType:meal_type
        mealPlanId:meal_plan_id
        status
      }
    }
  }
`;

export const DELETE_EXISTING_MEAL_PLAN = gql`
  mutation DELETE_EXISTING_MEAL_PLAN($mealIds: [uuid!] = "") {
    delete_Shopping_List_Item(where: {meal_id: {_in: $mealIds}}) {
      affected_rows
    }
    delete_Meal(where: {id: {_in: $mealIds}}) {
      affected_rows
    }
  }
`;

export const INSERT_SHOPPING_LIST_FOR_USER = gql`
  mutation INSERT_SHOPPING_LIST_FOR_USER($user_id: uuid) {
    insert_User_To_Shopping_List_one(object: {user_id: $user_id}) {
      shopping_list_id
      user_id
    }
  }
`

export const INSERT_ITEMS_IN_SHOPPING_LIST = gql`
  mutation INSERT_ITEMS_IN_SHOPPING_LIST($items: [Shopping_List_Item_insert_input!]!) {
    insert_Shopping_List_Item(objects: $items) {
      returning {
        id
      }
    }
  }
`;

export const INSERT_MEAL_PLAN_WITH_ID = gql`
  mutation INSERT_MEAL_PLAN_WITH_ID($title: String = "", $description: String = "", $author: uuid = "", $author_profile_Image: String = "", $editable: Boolean = true, $access_type: String = "public", $meal_plan_id: uuid = "") {
    insert_Meal_Plan_one(object: { title: $title, description: $description, author: $author, author_profile_Image: $author_profile_Image, editable: $editable, access_type: $access_type, id: $meal_plan_id }) {
      author
      id
    }
  }
`;

export const UPDATE_SHOPPING_LIST_ITEM = gql`
  mutation UPDATE_SHOPPING_LIST_ITEM($where: Shopping_List_Item_bool_exp!, $set: Shopping_List_Item_set_input!) {
  update_Shopping_List_Item(where: $where, _set: $set) {
    affected_rows
    returning {
      id
      meal_id
      ingredient_id
      status
      serving_size
      shopping_list_id
      unit
      amount
    }
  }
}
`;
// example usage of UPDATE_SHOPPING_LIST_ITEM
// updateShoppingListItem({
//   variables: {
//     where: { ingredient_id: { _eq: "ingredient_uuid_1" } },
//     set: { status: "purchased" },
//   },
// });

export const DELETE_SHOPPING_LIST_ITEM = gql`
  mutation DELETE_SHOPPING_LIST_ITEM($where: Shopping_List_Item_bool_exp!) {
  delete_Shopping_List_Item(where: $where) {
    returning {
      id
      ingredient_id
      meal_id
      status
      recipe_id
      shopping_list_id
      unit
      amount
      serving_size
      }
    }
  }
`;

export const INSERT_MEAL_NOTE = gql`
  mutation INSERT_MEAL_NOTE($content: jsonb = "", $meal_plan_id: uuid = "", $meal_type: String = "", $scheduled_date_time: timestamp = "") {
    insert_Meal_Notes(objects: {content: $content, meal_plan_id: $meal_plan_id, meal_type: $meal_type, scheduled_date_time: $scheduled_date_time}) {
      returning {
        id
      }
    }
  }
`;

export const DELETE_MEAL_NOTE = gql`
  mutation MyMutation($note_id: uuid = "") {
    delete_Meal_Notes(where: {id: {_eq: $note_id}}) {
      returning {
        id
      }
    }
  }
`;


export const UPDATE_NOTE_STATUS = gql`
  mutation UPDATE_NOTE_STATUS($id: uuid = "", $status: String = "") {
    update_Meal_Notes_by_pk(pk_columns: {id: $id}, _set: {status: $status}) {
      status
      id
    }
  }
`

export const UPDATE_RECIPE_NUTRITIONAL_INFO = gql`
  mutation UPDATE_RECIPE_NUTRITIONAL_INFO($id: uuid = "", $metadata: jsonb = "") {
  update_Recipe_Variations_by_pk(pk_columns: {id: $id}, _set: {metadata: $metadata}) {
    metadata
  }
}


`




